import { TeamType } from 'types/team/team'
import { create } from 'zustand'

const teamCreationStore = (set: any) => ({
  // modals
  teamModalVisible: false,
  setTeamModalVisible: (state: boolean) =>
    set(() => ({ teamModalVisible: state })),

  teamLeadModalVisible: false,
  setTeamLeadModalVisible: (state: boolean) =>
    set(() => ({ teamLeadModalVisible: state })),

  coachModalVisible: false,
  setCoachModalVisible: (state: boolean) =>
    set(() => ({ coachModalVisible: state })),

  memberModalVisible: false,
  setMemberModalVisible: (state: boolean) =>
    set(() => ({ memberModalVisible: state })),

  // data values
  teamData: null,
  setTeamData: (state: TeamType) => set(() => ({ teamData: state })),

  // states
  isUpdatingTeam: false,
  setIsUpdatingTeam: (state: boolean) => set(() => ({ isUpdatingTeam: state })),
})

export const teamStore = create(teamCreationStore)
